import React, { useState } from "react";

import { useAnnotationStore } from "@perceptron/core";
import { AnnotationBadge } from "@perceptron/ui/components/annotationBadge";
import { cn } from "@perceptron/utils/cn";

import { ImageThumbnail } from "@demo/components/ImageThumbnail";

import { MediaTileRemoveButton } from "./MediaTileRemoveButton";
import { BaseMediaRendererProps } from "./types";

export const ImageRenderer: React.FC<BaseMediaRendererProps> = ({
  media,
  index,
  mediaSetId,
  onSelect,
  onRemove,
  showControls = true,
  className = "",
  loading,
}) => {
  // Get annotation count for this image
  const annotations = useAnnotationStore.getState().getAnnotations(mediaSetId, media.key);
  const annotationCount = annotations.length;

  const [isDragging, setIsDragging] = useState(false);

  return (
    <div
      className={cn(
        "group/tile relative size-full cursor-pointer overflow-hidden rounded-md shadow-[0_4px_4px_rgba(0,0,0,0.07)]",
        className,
      )}
      onClick={(e) => onSelect?.(e, index)}
      onTouchEnd={(e) => {
        if (isDragging) {
          setIsDragging(false);
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        onSelect?.(e, index);
      }}
      onTouchMove={() => {
        if (!isDragging) {
          setIsDragging(true);
        }
      }}
    >
      {showControls && <MediaTileRemoveButton index={index} testId={`delete-image-${index}`} onRemove={onRemove} />}
      <AnnotationBadge count={annotationCount} />
      <ImageThumbnail index={index} loading={loading} media={media} />
    </div>
  );
};
